import { Component } from "react";
import { connect } from "react-redux";
import { BetSlipHelper } from "../../../../../../../../../../../helpers/betSlipHelper";
import { marketPeriodHelper } from "../../../../../../../../../../../helpers/marketPeriodHelper";
import type {
  EventMarketType,
  EventRunnerType,
  EventType,
} from "../../../../../../../../../../../types/eventType";
import { MarketTypes } from "../../../../../../../../../../../utils/const";
import RenderOddsComponent from "../RenderOddsComponent/RenderOddsComponent";
import "./ThreewayMarketRunnerDetails.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
  addBetSlip: (...args: Array<any>) => any;
  displayType?: number;
}; //

class ThreewayMarketRunnerDetails extends Component<Props> {
  addBetSlip = (runner: EventRunnerType) => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };

  render() {
    const { event, market, marketType, displayType } = this.props;
    return (
      <div
        className={`market threeway ${
          marketType.marketType === MarketTypes.ONE_X_TWO && "market--one-x-two"
        }`}
      >
        {market.runners.map(runner => {
          if (marketPeriodHelper.shouldHideRunner(runner)) {
            return (
              <span
                key={"threeway" + runner.id}
                className="threeway-market__runner--empty"
              ></span>
            );
          }

          const displayType3 =
            displayType === 3 ||
            marketType.marketType === MarketTypes.HALF_FULL_TIME
              ? "display-type-3"
              : "";
          const showRunnerName =
            displayType === 7 &&
            marketType.marketType !== MarketTypes.ONE_X_TWO;
          const showHandicapValue =
            marketType.marketType === MarketTypes.RACE_TO;

          // BET-9465 Fill empty space for missing double chance runners
          const fillMarketRow =
            market.runners.length < 3 &&
            marketType.marketType === MarketTypes.DOUBLE_CHANCE
              ? "fill-market-row"
              : "";
          // Fix for cases of missing borders
          const addEndBorder =
            market.runners.length < 3 ? "add-end-border" : "";

          return (
            <span
              key={"threeway" + runner.id}
              onClick={() => {
                this.addBetSlip(runner);
              }}
              className={`threeway-market__runner ${displayType3} ${fillMarketRow} ${addEndBorder}`}
            >
              {!showHandicapValue && showRunnerName && (
                <div className="runner__name">{runner.name}</div>
              )}
              {showHandicapValue && (
                <div className="runner__name">
                  {runner.modalFormattedHandicap}
                </div>
              )}
              <RenderOddsComponent
                event={event}
                runner={runner}
                marketType={marketType}
              />
              {/* {this.props.renderOddsComponent(runner, marketType)} */}
            </span>
          );
        })}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(ThreewayMarketRunnerDetails) as any;
